<template>
    <div class="goods-item" @click="gotoGoods(row.id,row.prop_id,row.transaction_id)">
       <div class="goods_pic">
            <div class="box">
                <img class="goods_icon" :src="row.icon_num" alt="">
            </div>
       </div>
       <div class="goods_info">
            <div class="name_num">
                <div class="name">
                    <p>{{ row.goods_name }}</p>
                </div>
                <div class="num">
                    <span class="prefix">数量：</span>
                    <span>{{ row.num }}</span>
                </div>
            </div>
            <!-- <div class="price">
                <span class="prefix">参考价格：</span>
                <span class="yen">&yen;{{ row.price }}</span>
            </div> -->
       </div>
    </div>
</template>

<script>
export default {
    name: 'sellgoods-item',
    props: {
        row: [Array, Object],
    },
    filters: {

    },
    data() {
        return {
            
        }
    },
    methods: {
        gotoGoods(id,prop_id,item_id) {
            this.$router.push({
                name: 'onsell',
                query: {
                    id,
                    prop_id,
                    item_id
                }
            })
        }
    },
}
</script>

<style lang="less" scoped>
.goods-item {
    width: 17rem;
    background-color: #fff;
    margin-bottom: .8rem;
    border-radius: .6rem;
    padding-bottom: 1rem;
    overflow: hidden;
    cursor: pointer;
    &:active {
        opacity: 0.9;
    }
    &:nth-child(2n+1) {
        margin-right: 1rem;
    }
    .goods_pic {
        height: 8.6rem;
        width: 100%;
        background: url(../assets/bx/goods_bg.png) no-repeat 0 0 / 100% 100%;
        position: relative;
        .box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            width: 3rem;
            height: 3rem;
            background: url(../assets/bx/goods_kuang.png) no-repeat 0 0 / 100% 100%;
            .goods_icon {
                height: 100%;
            }
        }
    }
    .goods_info {
        padding: .7rem .8rem 0;
        .name_num {
            height: 4.5rem;
            display: flex;
            align-items: flex-start;
            position: relative;
            .name {
               font-size: 1.4rem;
               width: 100%;
               p {
                float: left;
               }
               .line2 {
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
               }
            }
            .num {
                position: absolute;
                right: 0;
                top: .1rem;
                white-space: nowrap;
                color: #aaa;
                font-size: 1.2rem;
                transform: scale(0.95);
                transform-origin: 100% 100%;
                .prefix {
                    display: inline-block;
                    transform: translateX(0.5rem);
                }
                .suffix {
                    color: var(--enough);
                }
            }
        }
        .price {
            word-break: break-all;
            font-size: 1.2rem;
            .prefix,
            .zw {
                color: #aaa;
            }
            .yen {
                color: var(--red);
                font-weight: 700;
            }
        }
    }
}
</style>